import styled from 'styled-components'

interface RowProps {
  highlight?: boolean
  error?: boolean
  bold?: boolean
  success?: boolean
}

export const Row = styled.div<RowProps>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  ${({ error, theme }) =>
    error &&
    `
      font-weight: 400;
      color: ${theme?.['-ds-warning-300']?.value};
    `};

  ${({ bold }) =>
    bold &&
    `
      font-weight: 400;
    `};

  ${({ highlight, theme }) =>
    highlight &&
    `
      color: ${theme?.['-ds-core-400']?.value};
      font-weight: 400;
    `};
`

export const LabelColumn = styled.div`
  width: 70%;
`

export const PriceColumn = styled.div`
  width: 30%;
  text-align: right;
`
